import { transport } from 'config/transport';

export function callApiGenerateAssets(congDoanId, academicYear, assetSource, assetType) {
    return transport.post(`/congDoan/${congDoanId}/assets/generate`, {}, { params: { academicYear, assetSource, assetType } });
}
